import {css} from 'lit';

export default css`

@media (max-width: 991px) {
  .off-canvas {
    position: absolute;
    z-index: 830;
    width: 70vw;
    min-width: 15rem;
    height: 100%;
    background: #fff;
    overscroll-behavior-y: contain;
    transition: all 0.3s;
  }
  .off-canvas__container {
    position: static;
  }
  .menu--hidden .off-canvas__container {
    display: none;
  }
  .off-canvas--fixed, .l-header--fixed .off-canvas {
    position: fixed;
    z-index: 1000;
    overflow: auto;
  }
  .off-canvas--fixed .off-canvas__container, .l-header--fixed .off-canvas .off-canvas__container {
    padding-bottom: 9rem;
  }
  .off-canvas--left {
    left: 0;
  }
  .menu--closed .off-canvas--left {
    transform: translateX(-105%);
  }
  .off-canvas--right {
    right: 0;
  }
  .menu--closed .off-canvas--right {
    transform: translateX(105%);
  }
  .menu--open .off-canvas {
    box-shadow: 0 10px 10px 5px rgba(25, 25, 25, 0.4);
  }
}

`;